
/**
 * 트윗 유형
 */
export type CreateTweetBodyJsonDataTweetType = typeof CreateTweetBodyJsonDataTweetType[keyof typeof CreateTweetBodyJsonDataTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTweetBodyJsonDataTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
